import React from "react";

const Team = () => {
  return (
    <section className="bg-chinese-black text-white" id="our-team">
      <div className="me-47 ms-47 pt-7 pb-7">
        <div>
          <h1 className="fs-56 lh-64 text-uppercase gilroy-bold pb-7 text-center text-orange-ryb">
            OUR TEAM
          </h1>
          <p className="fs-20 lh-30 text-align-justify">
            We have been supported by a team of highly experienced and qualified
            professionals, which helps us in offering an excellent range of
            Fresh Vegetables, Fresh Fruits, Nutritional Vegetables and Leafy
            Vegetables to the customers. These professionals make sure to
            procure the products as per the market demand. Our procuring agents
            select the best vendors for our organisation. The professionals
            associated with us manage all the business activities in the most
            efficient manner. They help us in achieving the organisational goals
            within the committed time frame.
          </p>
          <p className="fs-20 mt-5">
            Some of the members in our team are as follows:
          </p>
          <ul className="fs-18">
            <li>Procuring agents</li>
            <li>Warehousing experts</li>
            <li>Quality controllers</li>
            <li>Packaging experts</li>
            <li>Logistics experts</li>
          </ul>
        </div>

        <div>
          <h1 className="fs-56 lh-64 text-uppercase gilroy-bold pt-7 pb-7 text-center text-orange-ryb">
            VENDOR BASE
          </h1>
          <p className="fs-20 lh-30 text-align-justify">
            In order to offer a wide range of Fresh Vegetables, Fresh Fruits,
            Nutritional Vegetables and Leafy Vegetables in the market, we have
            associated ourselves with some of the most well-known vendors of the
            industry. The vendors for our organisation are selected on the basis
            of their goodwill, past clientele, competitive prices and others.
            Our procuring agents make sure to select the most deserving vendors
            for our organisation to source the vegetables and fruits as per the
            market demand. The vendors from whom we source these products have
            large farms & orchards where fruits and vegetables are grown or
            cultivated without using any type of harmful products like
            pesticides and others. Moreover, they grow these products by
            following traditional methods and others.
          </p>
        </div>

        <div>
          <h1 className="fs-56 lh-64 text-uppercase gilroy-bold pt-7 pb-7 text-center text-orange-ryb">
            WHY US?
          </h1>
          <ul className="fs-18">
            <li>Wide market presence</li>
            <li>Delivery assurance</li>
            <li>Effective packaging solutions</li>
            <li>Fresh and healthy range of fruits & vegetables</li>
            <li>Stringent quality parameters</li>
            <li>Highly skilled professionals</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Team;
